import Constants from 'common/constants'

import {
  ADD_GRADE,
  DELETE_GRADE,
  DELETE_MANY_GRADES,
  GET_GRADE,
  GET_GRADES,
  GET_SUBJECTS_GRADES,
  GET_SUBJECT_GRADES,
  GET_TEACHER_CLASS_GRADES,
  INACTIVATE_GRADE,
  REDUX_GET_GRADES,
  UPDATE_GRADE,
  UPDATE_GRADES_SEQUENCE,
} from './ActionTypes/ApiActionTypes'

export const getGrade = (id, onSuccess, onFailure) => {
  return {
    type: GET_GRADE,
    payload: {
      apiUrl: Constants.api_get_grade(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getGrades = (body, onSuccess, onFailure) => {
  return {
    type: GET_GRADES,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_grades,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: REDUX_GET_GRADES,
      onFailure,
    },
  }
}
export const addGrade = (body, onSuccess, onFailure) => {
  return {
    type: ADD_GRADE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_add_grade,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const deleteGrade = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_GRADE,
    payload: {
      apiUrl: Constants.api_delete_grade(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const inactivateGrade = (id, onSuccess, onFailure) => {
  return {
    type: INACTIVATE_GRADE,
    payload: {
      apiUrl: Constants.api_inactivate_grade(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: {},
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const deleteManyGrades = (ids, onSuccess, onFailure) => {
  return {
    type: DELETE_MANY_GRADES,
    payload: {
      apiUrl: Constants.api_delete_many_grades,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body: {ids: ids},
      onSuccess,
      onFailure,
    },
  }
}
export const updateGrade = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_GRADE,
    payload: {
      apiUrl: Constants.api_update_grade(id),
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSubjectGrades = (body, onSuccess, onFailure) => {
  return {
    type: GET_SUBJECT_GRADES,
    payload: {
      apiUrl: Constants.api_get_subject_grades,
      getString: '',
      body,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateGradeSequence = (body, onSuccess, onFailure) => {
  return {
    type: UPDATE_GRADES_SEQUENCE,
    payload: {
      apiUrl: 'school/grades/sequence',
      getString: '',
      body,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const subjectsGrades = (body, onSuccess, onFailure) => {
  return {
    type: GET_SUBJECTS_GRADES,
    payload: {
      apiUrl: 'school/grades/subjects-grades',
      getString: '',
      body,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const teacherClassGrades = (body, onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_CLASS_GRADES,
    payload: {
      apiUrl: 'school/grades/teacher-index',
      getString: '',
      body,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
